import React, { Fragment, useState } from "react";
import "./productDetails.css";
import * as actions from "../../actions";
import { connect } from "react-redux";
import {
  Sidebar,
  SideBarButtons,
  SidebarHeader,
  SidebarViewAll,
  SideBar,
  SidebarRight,
  SidebarLeft,
} from "../layouts/layout1";
import Title from "../title/title";
import { Link } from "react-router-dom";
import Tag from "../tag/tag";
import SectionStart from "../sectionStart/sectionStart";
import Button from "../button/button";
import Table from "../table/table";
import ApiProductTableRow from "../apiProductTableRow/apiProductTableRow";
import SimpleButtonWrapper from "../simpleButtonWrapper/simpleButtonWrapper";
import SubscribePopover from "../changeSubscriptionStatus/subscribePopover/subscribePopover";
import ChangeLog from "../changeLog/changeLog";
import v4 from "uuid";
import _ from "lodash";
import Heading from "../heading/heading";

import ProductNotificationsSubscribe from "../apiProduct/productNotificationsSubscribe/productNotificationsSubscribe";

const PRODUCT_TABLE_HEADER = [
  {
    title: "PLAN NAME",
  },
  {
    title: "",
    className: "accordion_column",
  },
  {
    title: "DEFAULT PLAN",
  },
];

function ProductDetails(props) {
  const { product, changeLog, isLoggedIn, openModal } = props;
  const { deprecated, version, description, subscribed, uuid, label } = product;
  const productRouteIdentifier = product.alias || product.uuid;

  // State for copy button feedback
  const [copyFeedback, setCopyFeedback] = useState("");

  // Function to copy raw description to clipboard
  const copyRawDescription = async () => {
    try {
      // Copy the raw HTML/markdown content as-is
      const rawContent = description || "";

      await navigator.clipboard.writeText(rawContent);
      setCopyFeedback("Copied!");

      // Reset feedback after 2 seconds
      setTimeout(() => {
        setCopyFeedback("");
      }, 2000);
    } catch (err) {
      console.error("Failed to copy:", err);
      setCopyFeedback("Failed to copy");
      setTimeout(() => {
        setCopyFeedback("");
      }, 2000);
    }
  };

  return (
    <SectionStart>
      <SideBar>
        <SidebarLeft>
          <Fragment>
            <SidebarHeader>
              <Title type="small">
                <Tag className="display-effect">OPEN API DOCUMENTATIONS</Tag>
              </Title>
              <SideBarButtons classNameWrapper="ApiButtons">
                {product.apis && product.apis.length > 0
                  ? product.apis.map((api) => {
                      console.log("API endpoint data:", {
                        title: api.title,
                        alias: api.alias,
                        name: api.name,
                      });

                      // Use alias which already contains the full path like "/documentation/Account-Information-Berlin-Group-v1"
                      let targetUrl =
                        api.alias ||
                        `/documentation/${api.title || api.name || ""}`;

                      console.log("Generated targetUrl:", targetUrl);

                      return (
                        <Link
                          key={api.uuid || api.title}
                          to={targetUrl}
                          target={"_blank"}
                        >
                          <Button className="ApiButton btn">
                            {api.title}
                            <span className="icon-icon_open" />
                          </Button>
                        </Link>
                      );
                    })
                  : null}
              </SideBarButtons>
            </SidebarHeader>
            <SidebarViewAll />
          </Fragment>
        </SidebarLeft>
        <SidebarRight>
          <Fragment>
            <div className="nbg_table accordion_table">
              <div>
                <Tag>{label}</Tag>
              </div>
              <div className="array_descr">
                <span className="path_big">
                  {product.title.toUpperCase() + " " + version}
                </span>
                <br /> DOCUMENTATION
              </div>
              <div>
                {deprecated ? (
                  <div className="text-align-right">
                    <span className="tag tag--DEVELOPMENT">Deprecated</span>
                  </div>
                ) : null}
                {subscribed !== null && isLoggedIn && (
                  <div
                    className={
                      deprecated
                        ? "notification__subscription_deprecated"
                        : "notification__subscription"
                    }
                  >
                    <ProductNotificationsSubscribe
                      uuid={uuid}
                      subscribed={subscribed}
                    />
                  </div>
                )}
              </div>

              <div className="description-container">
                <div className="description-header">
                  <button
                    className="copy-description-btn"
                    onClick={copyRawDescription}
                    title="Copy raw description content"
                  >
                    <span className="copy-icon">📋</span>
                    {copyFeedback ? (
                      <span className="copy-feedback">{copyFeedback}</span>
                    ) : (
                      <span className="copy-text">Copy Raw Content</span>
                    )}
                  </button>
                </div>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                  }}
                  dangerouslySetInnerHTML={{ __html: description }}
                />
              </div>

              {changeLog && changeLog.length > 0 ? (
                <div className="changelog-container">
                  <Heading
                    level="5"
                    style={{ color: "white", fontWeight: "400" }}
                  >
                    ChangeLog
                  </Heading>
                  {_.orderBy(
                    changeLog,
                    [
                      (item) => {
                        // Parse version to handle numeric sorting properly
                        // e.g., "2.10" should come after "2.9"
                        const version = item.version || "";
                        const parts = version.toString().split(".");
                        // Pad each part to ensure proper sorting
                        return parts
                          .map((part) => part.padStart(10, "0"))
                          .join(".");
                      },
                    ],
                    ["desc"]
                  ).map((item) => (
                    <ChangeLog key={v4()} {...item} />
                  ))}
                </div>
              ) : null}
              <div style={{ marginTop: "2rem" }}>
                <Table
                  cellsNumber={2}
                  header={PRODUCT_TABLE_HEADER}
                  rows={(product.apis || []).map((api) => ({
                    ...api,
                    productAlias: product.alias,
                    productId: product.uuid,
                  }))}
                  RenderRow={ApiProductTableRow}
                />
              </div>
            </div>
            {isLoggedIn ? (
              <SimpleButtonWrapper
                style={{ marginTop: "8px" }}
                position="right"
              >
                <Button onClick={openModal} electro>
                  SUBSCRIBE
                </Button>
              </SimpleButtonWrapper>
            ) : (
              <SimpleButtonWrapper
                style={{ marginTop: "8px" }}
                position="right"
              >
                <Button electro style={{ cursor: "not-allowed" }}>
                  SUBSCRIBE
                </Button>
              </SimpleButtonWrapper>
            )}
          </Fragment>
        </SidebarRight>
      </SideBar>
    </SectionStart>
  );
}

const mapStateToProps = (state) => ({
  isLoggedIn: state.applicationUser?.isLoggedIn,
});

const mapDispatchToProps = (dispatch) => ({
  changeSubscriptionStatus: (payload) => {
    dispatch(actions.changeSubscriptionStatus(payload));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ProductDetails);
